"use client"

import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { TextField } from './TextField'

function PriceFilter() {
  const router = useRouter()
  const [priceFrom, setPriceFrom] = useState('')
  const [priceTo, setPriceTo] = useState('')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      const priceFromParam = params.get('priceFrom') || ''
      const priceToParam = params.get('priceTo') || ''
      setPriceFrom(priceFromParam)
      setPriceTo(priceToParam)
    }
  }, [])

  const handlePriceBlur = (from: string, to: string) => {
    if (typeof window !== "undefined" ) {
    setPriceFrom(from)
    setPriceTo(to)
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      if (from) {
        params.set('priceFrom', from)
      } else {
        params.delete('priceFrom')
      }
      if (to) {
        params.set('priceTo', to)
      } else {
        params.delete('priceTo')
      }
      router.push(`${window.location.pathname}?${params.toString()}`)
    }
  }
  }

  return (
    <div>
      <h3 className="font-semibold mb-2">Price</h3>
      <div className="flex space-x-2 mb-4">
        <TextField
          value={priceFrom}
          onChange={(value) => handlePriceBlur(value, priceTo)}
          placeholder="$ from"
          validationRule={/^\d*$/}
          validationMessage="Only numbers are allowed"
        />
        <TextField
          value={priceTo}
          onChange={(value) => handlePriceBlur(priceFrom, value)}
          placeholder="$ to"
          validationRule={/^\d*$/}
          validationMessage="Only numbers are allowed"
        />
      </div>
    </div>
  )
}

export default PriceFilter